module.exports = __webpack_public_path__ + "img/3.cc257e72.png";